import axios from 'axios';
import { AUTH_SUCCESS, AUTH_LOGOUT, AUTH_ERROR, AUTH_ERROR_MESSAGE_REMOVE, SIGN_UP_ERROR } from './actionTypes';
import { AUTH_BASE_URL, AUTH_KEY, AUTH_SIGN_UP, AUTH_SIGN_IN_WITH_PASSWORD } from '../../constants';

export const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('userId')
  localStorage.removeItem('expirationDate')

  return { type: AUTH_LOGOUT }
}

export const authError = () => ({ type: AUTH_ERROR })

export const signUpError = () => ({ type: SIGN_UP_ERROR })

export const authErrorMessageRemove = () => ({ type: AUTH_ERROR_MESSAGE_REMOVE })

export const autoLogout = (time) => dispatch => {
  setTimeout(() => {
    dispatch(logout())
  }, time * 1000)
}

export const authSuccess = (token) => ({ type: AUTH_SUCCESS, token })

export const auth = (email, password, isLogin) => async dispatch => {
  const authData = {
    email,
    password,
    returnSecureToken: true
  }

  let url = `${AUTH_BASE_URL}:${AUTH_SIGN_UP}?key=${AUTH_KEY}`

  if (isLogin) {
    url = `${AUTH_BASE_URL}:${AUTH_SIGN_IN_WITH_PASSWORD}?key=${AUTH_KEY}`
  }
  try {
    const response = await axios.post(url, authData)
    const data = response.data

    //time of session, i.e. value of expiresIn is 3600 sec
    const expirationDate = new Date(new Date().getTime() + data.expiresIn * 1000)

    localStorage.setItem('token', data.idToken)
    localStorage.setItem('userId', data.localId)
    localStorage.setItem('expirationDate', expirationDate)

    dispatch(authSuccess(data.idToken))
    dispatch(autoLogout(data.expiresIn))
  }
  catch {
    if (!isLogin) {
      dispatch(signUpError())
    } else {
      dispatch(authError())
    }

  }
}

export const autoLogin = () => dispatch => {
  const token = localStorage.getItem('token')
  if (!token) {
    dispatch(logout())
  } else {
    const expirationDate = new Date(localStorage.getItem('expirationDate'))
    if (expirationDate <= new Date()) {
      dispatch(logout())
    } else {
      dispatch(authSuccess(token))
      dispatch(autoLogout((expirationDate.getTime() - new Date().getTime()) / 1000))
    }
  }
}
